export const MODAL_TITLE = 'Lane Departure Warning';
